import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 75vh;
  overflow-y: auto;
  padding: 4px;
`;

export const SectionHeading = styled.h3`
  margin: 0;
  font-weight: bold;
  color: #444141;
`;

export const HeadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ProfileFieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const FieldGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;

  label {
    font-weight: 600;
    color: #444141;
    white-space: nowrap;
  }
`;

export const HintText = styled.div`
  color: #8c8c8c;
  font-size: 14px;
  padding: 8px 0;
`;

export const NoSerialText = styled.span`
  color: #a8a8a8;
  font-size: 13px;
  font-style: italic;
`;

const tableBase = `
  width: 100%;
  border-collapse: collapse;

  th {
    background: #eef0f2;
    color: #444141;
    text-align: left;
    padding: 8px;
    border-bottom: 2px solid #dcdfe3;
    font-weight: bold;
    font-size: 13px;
  }

  td {
    padding: 8px;
    border-bottom: 1px solid #e6ebf0;
    vertical-align: middle;
    font-size: 13px;
  }
`;

export const CurrentDataTable = styled.table`
  ${tableBase}
`;

export const StandSelectionTable = styled.table`
  ${tableBase}

  td:not(:first-child) {
    min-width: 220px;
  }
`;
